import { render, staticRenderFns } from "./UploadIdCard.vue?vue&type=template&id=24e0a40b&scoped=true"
import script from "./UploadIdCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadIdCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UploadIdCard.vue?vue&type=style&index=0&id=24e0a40b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e0a40b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/examreg-client-prod-tc/exam-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24e0a40b')) {
      api.createRecord('24e0a40b', component.options)
    } else {
      api.reload('24e0a40b', component.options)
    }
    module.hot.accept("./UploadIdCard.vue?vue&type=template&id=24e0a40b&scoped=true", function () {
      api.rerender('24e0a40b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/personalCenter/views/components/UploadIdCard.vue"
export default component.exports